module.exports = __webpack_public_path__ + "static/img/left-top-row-3.a957cb9d.webp";